import { gql } from 'apollo-angular';

export const ACCOUNT_BRANCHES_FRAGMENT = gql`
  fragment AccountBranchesFragment on Account {
    branches {
      id
      name
    }
  }
`;
